module.exports = __webpack_public_path__ + "static/media/circle-filled-blue.b37af7e0.svg";